import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Logo from "../images/golden-gate-logo.png"
import AthelasLogo from "../images/athelas-logo.svg"

const Header = ({ siteTitle }) => (
  <header
    style={{
      background: `white`,
      marginBottom: `1.45rem`,
      position: 'fixed',
      width: '100%',
      zIndex: '10',
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        maxWidth: '90%',
        padding: `1.45rem 1.0875rem 0rem 1.0875rem`,
      }}
    >
      <h1>
        <Link to='/'>
          <img src={Logo} width='250px' alt='Golden Gate Pharmacy' aria-label='Golden Gate Pharmacy' />
        </Link>
      </h1>
      <h2>
        <Link to='/' className='nav-link'>Home</Link>
        <Link to='/faq' className='nav-link'>FAQs</Link>
        <Link to='/request-demo' className='nav-link'>Request A Demo</Link>
      </h2>
      <div className='trusted-partner-container' onClick={() => window.location = 'http://www.athelas.com'}>
        <img src={AthelasLogo} alt='Athelas Logo' className='athelas-logo'/>
        <span className='trusted-partner'>Athelas Trusted Partner</span>
      </div>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: `Golden Gate Pharmacy`,
}

export default Header
